import { ProductDepartmentListPage } from "@/features/product-department/pages/ProductDepartmentListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/product-department/")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["product_department.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductDepartmentListPage,
});
